// External deps
import { useContext } from 'react';

// Internal deps
import { AppContext } from '../context/AppProvider';

export default function useApp() {
  return useContext(AppContext);
}
